import {Component, HostBinding, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {FeatureTypeService} from '@catcore/services';
import {Feature} from '@catcore/services/feature/feature';
import {GenericLinkedResource} from '@catcore/types/base';
import {GenericResourceService} from '@catfeatures/services/generic-resource.service';
import {ResourceHandler} from '@catfeatures/types';
import {FeatureUnitsService} from '@catmodules/models/feature-units/services/feature-units.service';
import {InputParameterComponent} from '@catmodules/models/parameters/components/input-parameter/input-parameter.component';
import {EntityForm} from '@catmodules/ui-models/shared/entity-form';
import {isNullOrUndefined} from 'util';
import {ParametersService} from "@catmodules/models/parameters/services/parameters.service";
import {Subscription} from "rxjs";

const componentBaseName = 'feature-parameter-form';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');

@Component({
  selector: 'cat-feature-parameter-form',
  templateUrl: './feature-parameter-form.component.html',
})
export class FeatureParameterFormComponent extends EntityForm implements OnInit, OnDestroy {
  @HostBinding('class') classNames = defaultClassNames;

  constructor(
    formBuilder: FormBuilder,
    private featureService: FeatureTypeService,
    private featureUnitService: FeatureUnitsService,
    private genericResourceService: GenericResourceService,
    private parametersService: ParametersService,
  ) {
    super(formBuilder);
  }

  private feature: Feature;
  private featureSubscription: Subscription;

  ngOnInit() {
    this.featureSubscription = this
      .featureService
      .getCurrent()
      .subscribe((feature: Feature) => this.feature = feature);
  }

  ngOnDestroy() {
    this.featureSubscription.unsubscribe();
  }

  private findCurrentUnitInFeature(feature: Feature): ResourceHandler {
    let handler: ResourceHandler = null;
    this
      .featureService
      .extractUnitsFor(feature)
      .map((item: GenericLinkedResource) => {
        const service = this.genericResourceService.findServiceForResource(item.href);
        if (service.isReady()) {
          return service;
        }
      })
      .forEach((service: ResourceHandler) => {
        if (!isNullOrUndefined(service) && service.isReady()) {
          this.featureUnitService
            .extractParametersFor(service.extractCurrent())
            .forEach((item: GenericLinkedResource) => {
              if (item.href === this.getModel()._links.self.href) {
                handler = service;
              }
            });
        }

      });

    return handler;

  }

  isFileParameter(parameter) {
    return this.parametersService.isFileParameter(parameter);
  }

  protected modifyUpdatedFormValues(values: any[]): any[] {
    // TODO method logic if necessary
    return values;
  }

  protected afterFormSubmit() {
    const service = this.findCurrentUnitInFeature(this.feature);
    if (service) {
      service.refresh();
    }

  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/feature-parameter/components/feature-parameter-form/feature-parameter-form.component.ts